export const appwriteConfig = {
  endpoint: import.meta.env.VITE_APPWRITE_ENDPOINT || 'https://api.accesible.club/v1',
  projectId: import.meta.env.VITE_APPWRITE_PROJECT_ID || '6a8d4df5000c4b3d204d',
  projectName: import.meta.env.VITE_APPWRITE_PROJECT_NAME || 'accesible-club',
  databaseId: 'community',
  profilesTableId: 'profiles',
  /** Function que recibe la mayoría de las acciones del backend (ver command-gateway). */
  managementFunctionId: import.meta.env.VITE_MANAGEMENT_FUNCTION_ID || 'management-command',
  /** La biblioteca de medios vive en su propia Function (sube a R2). */
  mediaFunctionId: import.meta.env.VITE_MEDIA_FUNCTION_ID || 'media',
  /** Generación de IA (chat de prueba del panel de admin) — ver docs/0004-ai-generate.md en el backend. */
  aiGenerateFunctionId: import.meta.env.VITE_AI_GENERATE_FUNCTION_ID || 'ai-generate',
  /** Señales de infraestructura del servidor (deploys, salud del VPS) — ver
   * functions/ops en el backend. */
  opsFunctionId: import.meta.env.VITE_OPS_FUNCTION_ID || 'ops',
} as const;
